import { Component, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { DefineBootboxId } from 'app/resources/classes/define-bootbox-id';
import { Headers } from '@angular/http';
import { MainService, PagamentoService } from 'app/resources/services/index';
import { MoedaUtils } from 'app/resources/utils/moeda-utils';
import { EnumTipoBoleto } from 'app/resources/enum/enumTipoBoleto';
import { ResponseCIP } from 'app/resources/models/ResponseCIP';
import { RequestPagamento } from 'app/resources/models/RequestPagamento';
import { EnumStatusBoleto } from 'app/resources/enum/enumStatusBoleto';
import { EnumTipoEnvio } from 'app/resources/enum/enumTipoEnvio';

@Component({
  selector: 'app-novo-pagamento-lote',
  templateUrl: './novo-pagamento-lote.component.html',
})

export class NovoPagamentoLoteComponent implements OnInit {

  public readonly enumTipoBoleto = EnumTipoBoleto;
  private readonly enumStatusBoleto = EnumStatusBoleto;
  public enumTipoEnvio = EnumTipoEnvio;
  public rowsCSV: string[] = [];
  public inputLinhaDigitavel = '';
  public tipoEnvio: string;
  public bootboxAlertComId: DefineBootboxId = new DefineBootboxId();
  public ep: string;

  constructor(public mainService: MainService, public pagamentoService: PagamentoService, public router: Router) { }

  ngOnInit() {
    this.tipoEnvio = this.enumTipoEnvio.ARQUIVO;
    this.ep = '';
    window.scrollTo(0, 0);
    this.deleteBoletos();
  }

  public onFileChange(event: any) {
    const fileInput = event.target;
    const file = event.target.files[0];

    if (!file) {
      this.bootboxAlertComId.alerta('Selecione um arquivo CSV.');
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const csvText = e.target.result;
      this.processCSV(csvText);
      fileInput.value = '';
    };
    reader.readAsText(file);
  }

  private processCSV(csvText: string) {
    const rows = csvText
      .split('\n')
      .map((row) => row.trim())
      .filter((row) => row.length > 0);

    if (rows.length < 2) {
      this.bootboxAlertComId.alerta('O arquivo CSV deve conter pelo menos um boleto.')
      return;
    }

    const rowSemCaracteresEspeciais = (row: string) =>
      this.clearCaracteresEspeciais(row)

    this.rowsCSV = rows.map(rowSemCaracteresEspeciais)
      .filter((row) => row);

    this.setDadosBoleto();
  }

  private setDadosBoleto() {
    if (this.isBoletoDuplicado()) {
      this.bootboxAlertComId.alerta('O arquivo contém itens duplicados!')
      return
    }

    this.rowsCSV.map((line) => (
      this.mainService.pagamentoService.loteBoletos.push(this.setLinhaDigitavelBoleto(line))
    ));

    this.mainService.pagamentoService.validateLoteBoletos()
  }

  private isBoletoDuplicado(inputLinhaDigitavel?: string) {
    if (inputLinhaDigitavel) {
      return this.rowsCSV.some(item => item === inputLinhaDigitavel)
    } else {
      const arraySet = new Set(this.rowsCSV);
      return arraySet.size !== this.rowsCSV.length;
    }
  }

  private clearCaracteresEspeciais(item: string) {
    if (item) {
      return item.replace(/[^0-9]/g, '');
    }
  }

  private setLinhaDigitavelBoleto(linhaDigitavel: string): ResponseCIP {

    return {
      status: '',
      message: '',
      valuePoints: null,
      observacao: '',
      isEditing: false,
      barcodeDetails: {
        bankCode: '',
        bankName: '',
        barcode: '',
        digitableLine: this.clearCaracteresEspeciais(linhaDigitavel),
        dueDate: '',
        value: null,
        type: ''
      },
      paymentInfo: {
        recipientDocument: '',
        recipientName: '',
        payerDocument: '',
        payerName: '',
        dueDate: '',
        limitDate: null,
        minValue: null,
        maxValue: null,
        fineValue: null,
        interestValue: null,
        originalValue: null,
        totalUpdatedValue: null,
        totalDiscountValue: null,
        totalAdditionalValue: null
      }
    }
  }

  public addBoleto() {
    const linhaDigitavel = this.clearCaracteresEspeciais(this.inputLinhaDigitavel);
    if (linhaDigitavel) {
      if (this.isBoletoDuplicado(linhaDigitavel)) {
        return this.bootboxAlertComId.alerta('Esse item já está incluso na lista!')
      }
      this.rowsCSV.push(linhaDigitavel)
      this.mainService.pagamentoService.loteBoletos.push(this.setLinhaDigitavelBoleto(linhaDigitavel))
      this.mainService.pagamentoService.validateLoteBoletos()
      this.inputLinhaDigitavel = '';
    }
  }

  public deleteBoleto(boleto: ResponseCIP) {
    const indice = this.mainService.pagamentoService.loteBoletos.findIndex((item) => item === boleto);
    this.mainService.pagamentoService.loteBoletos.splice(indice, 1);
    this.rowsCSV.splice(indice, 1);

    this.mainService.pagamentoService.valotTotalBoletosPontos -= boleto.valuePoints
    this.mainService.pagamentoService.valotTotalBoletos -= boleto.barcodeDetails.value
    this.mainService.pagamentoService.checkBoletosValidosParaPagamento()

    if (this.mainService.pagamentoService.loteBoletos.length < 1) {
      this.deleteBoletos();
    }
  }

  public deleteBoletos() {
    this.rowsCSV = [];
    this.mainService.pagamentoService.loteBoletos = [];
    this.mainService.pagamentoService.boletosInvalidos = [];
    this.mainService.pagamentoService.requisicoesLoteBoletosConcluidas = false;
    this.mainService.pagamentoService.valotTotalBoletos = 0;
    this.mainService.pagamentoService.valotTotalBoletosPontos = 0;
    window.scrollTo(0, 0);
  }

  public deleteBoletosInvalidos() {
    this.mainService.pagamentoService.loteBoletos = this.mainService.pagamentoService.loteBoletos.filter(item => item.status === this.enumStatusBoleto.NAO_PAGO)
    this.setBoletosInvalidos();
    if (this.mainService.pagamentoService.loteBoletos.length < 1) {
      this.deleteBoletos();
    }
  }

  private setBoletosInvalidos() {
    this.mainService.pagamentoService.boletosInvalidos = this.mainService.pagamentoService.loteBoletos.filter(item => item.status !== this.enumStatusBoleto.NAO_PAGO);
  }

  public setBoletoParaPagamento(ticket: ResponseCIP): RequestPagamento {
    return {
      valorMoeda: ticket.barcodeDetails.value,
      vencimento: ticket.barcodeDetails.dueDate,
      destinatario: ticket.paymentInfo.recipientName,
      documento: this.clearCaracteresEspeciais(ticket.paymentInfo.recipientDocument),
      beneficiarioDocumento: ticket.paymentInfo.payerDocument,
      banco: ticket.barcodeDetails.bankName,
      linhaDigitavel: ticket.barcodeDetails.digitableLine,
      tipo: this.setTipoBoleto(ticket),
      valorDescontoMoeda: ticket.paymentInfo.totalDiscountValue,
      observacao: ticket.observacao
    }
  }

  private setTipoBoleto(ticket: ResponseCIP): string {
    if (ticket.barcodeDetails.type === this.enumTipoBoleto.SIMPLES) {
      return this.enumTipoBoleto.boleto
    } else if (ticket.barcodeDetails.type === this.enumTipoBoleto.ARRECADACAO) {
      return this.enumTipoBoleto.conta_consumo
    }
  }

  public applyConversion(): number {
    return MoedaUtils.pontoToMoeda(this.mainService.pagamentoService.valotTotalBoletos, this.mainService.cartaoService.cartao.indiceMoeda);
  }

  private checkBoletosSemDescricao() {
    return this.mainService.pagamentoService.loteBoletos.some(item => !item.observacao)
  }

  public payBoletos() {
    if (this.mainService.pagamentoService.boletosInvalidos.length > 0) {
      return this.bootboxAlertComId.alerta('Existem boletos inválidos para pagamentos, exclua-os e envie novamente!')
    }
    if (this.checkBoletosSemDescricao()) {
      return this.bootboxAlertComId.alerta('Existem boletos sem descrição, preencha-os e tente novamente!')
    }

    this.mainService.pagamentoService.processando = true;
    const boletos = [];
    this.mainService.pagamentoService.loteBoletos.map(item => {
      boletos.push(this.setBoletoParaPagamento(item))
    })
    const cabecalho: Headers = new Headers();
    cabecalho.append('Authorization', 'Basic ' + this.mainService.sessionService.getAuthBasic());
    cabecalho.append('X-Auth-Ep', this.ep);
    this.mainService.http.pathRest()
      .post('cartao/pagamento/pagamentos', boletos, true, cabecalho)
      .subscribe(
        sucesso => {
          this.mainService.saldoService.initialize();
          this.deleteBoletos();
          this.mainService.pagamentoService.processando = false;
          this.router.navigate(['/pagamentos']);
          this.bootboxAlertComId.alerta('O pagamentos foram realizados com sucesso!');
        }, erro => {
          this.mainService.pagamentoService.processando = false;
          this.bootboxAlertComId.alerta(erro.text());
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/pagamento/novo-pagamento-lote/novo-pagamento-lote.component.ts